module.exports = __webpack_public_path__ + "static/Infographic4_3-Taoyuan-e833d8aa5db80e7ebef9291379f7b315.png";